module.exports = __webpack_public_path__ + "media/images/athletes/1774-b643386a35b1c67d15e298843f22f96a.png";